import { useMemo } from "react";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { toBackendWidgetRef } from "report/report-creation/content/types";
import fetchWidgetDetails from "report/report-creation/content/fetchWidgetDetails";
const generateKey = (widgets) => widgets.map(({ widgetId }) => widgetId).sort();
const useWidgetDetails = (widgets) => {
  const keys = useMemo(() => generateKey(widgets), [widgets]);
  const widgetRefs = useMemo(() => widgets.map(toBackendWidgetRef), [widgets]);
  const { data, isFetching } = useQuery({
    queryKey: keys,
    queryFn: () => fetchWidgetDetails(widgetRefs),
    placeholderData: keepPreviousData
  });
  return { data, isLoading: isFetching };
};
export default useWidgetDetails;
